<template>
  <div class="teams-promo-wrapper">
    <Button class="!w-full" data-testid="sidebar-footer-signup" type="solid" variant="secondary-blue" size="medium" :submit="true" @click="onSignUp">
      Get Zight for Free
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/storybook';
import { useAuthModals } from '@/composables/useAuthModals';
import './sidebar.css';

const { showSignUpModal } = useAuthModals();

const onSignUp = () => {
  showSignUpModal({
    signedUpFrom: 'viewer_sidebar_footer',
    utmContent: 'sidebar_footer',
  });
};
</script>
